import React, { useState } from 'react'
import Hyderabad from './Hyderabad'
import Karachi_inner from './Karachi_inner'

const Karachi = () => {

    const [data, setData] = useState(false)
    
    return (
        <>
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="province_heading">
                    <h1>Sindh</h1>
                    </div>
                </div>
            </div>
        </div>
        <div className="karachi_main">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <div className='karachi_1' onClick={()=>setData("Karachi")} >
                        <h1>Karachi</h1>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className='hyderabad_1' onClick={()=>setData("Hyderabad")} >
                        <h1>Hyderabad</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {data ===("Karachi") && <Karachi_inner/> }
        {data ===("Hyderabad") && <Hyderabad/>}

        </>
    )
}

export default Karachi
